<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Breadcrumb, Section, Module } from '@storefront/types';

  defineProps({
    breadcrumbs: { type: Array as PropType<Breadcrumb[]>, required: true },
    sections: { type: Array as PropType<Section[]>, required: true },
    module: { type: Object as PropType<Module>, required: true },
  });
</script>
<template>
  <main id="main" class="container">
    <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
    <SfHeading type="h1" class="privacy-policy-heading" v-html="module.title" />
    <div class="privacy-policy-description" v-html="module.descriptionShort" />
    <SectionRenderer :sections="sections" />
  </main>

  <RouterView />
</template>
<style scoped lang="scss">
  .privacy-policy-description {
    margin: 1rem 0 2rem;
  }

  @media(max-width: 992px) {
    .privacy-policy-heading,
    .privacy-policy-description {
      padding: 0 0.625rem;
    }
  }
</style>
